import React, { ReactElement, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import ScrollToTop from 'components/scrollToTop/ScrollToTop';
import Splash from 'internal/components/Splash';
import ThemeProvider from 'internal/providers/ThemeProvider';
import useApi, { Methods } from 'internal/hooks/useApi';
import { saveRemoteConfig } from 'internal/actions/appActions';
import { selectCollId, selectCollName } from 'internal/selectors/remoteConfigSelectors';
import { CONFIG_ENDPOINT } from 'internal/constants/api';
import { RemoteConfigType } from 'internal/types/remoteConfig';
import { selectSessionToken } from 'internal/selectors/authSelectors';
import { UserType } from 'pages/Account/types/user';
import { USER_DETAIL_ENDPOINT } from 'pages/Account/constants/endpoints';
import { setUser } from 'pages/Account/actions/userActions';
import Router from 'router/Router';
import Snackbar from '../../components/Snackbar/Snackbar';
import withConfig from '../../hoc/withConfig';

function App(): ReactElement {
  const dispatch = useDispatch();
  const id_coll = useSelector(selectCollId);
  const collectivityName = useSelector(selectCollName);
  const token = useSelector(selectSessionToken);

  const { request: fetchUser, response: responseUser } = useApi<UserType>(Methods.GET, USER_DETAIL_ENDPOINT);

  const { request, response } = useApi<RemoteConfigType>(Methods.GET, CONFIG_ENDPOINT);

  useEffect(() => {
    request();
  }, [id_coll, request, token]);

  useEffect(() => {
    if (token) {
      fetchUser();
    }
  }, [token]);

  useEffect(() => {
    if (responseUser?.success && responseUser?.data) {
      dispatch(setUser(responseUser.data));
    }
  }, [responseUser]);

  useEffect(() => {
    if (response?.success && response.data) {
      dispatch(saveRemoteConfig(response.data));
    }
  }, [response]);

  return (
    <BrowserRouter>
      <Helmet>
        <meta charSet={'utf-8'} />
        <title>{collectivityName}</title>
      </Helmet>
      <ThemeProvider>
        <ScrollToTop />
        <Router />
        <Snackbar />
        <Splash />
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default withConfig(App);
